import { useState, useCallback } from 'react'
import { RefreshCw, Wallet } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { DEFAULT_PAGE_SIZE, ListPagination } from '@/components/common/ListPagination'
import { DepositLogTable } from './components/DepositLogTable'
import { useSupplierDepositLogs, useSupplierDepositBalance } from '@/hooks/useSupplierDeposit'

export function SupplierDepositPage() {
	const [params, setParams] = useState({
		page: 1,
		page_size: DEFAULT_PAGE_SIZE,
	})

	// 查询余额和变动记录
	const { data: balance, isLoading: isBalanceLoading } = useSupplierDepositBalance()
	const { data, isLoading, refetch } = useSupplierDepositLogs(params)

	// 刷新全部数据
	const handleRefresh = useCallback(() => {
		refetch()
	}, [refetch])

	// 分页处理
	const handlePageChange = useCallback((page: number) => {
		setParams((prev) => ({ ...prev, page }))
	}, [])

	const handlePageSizeChange = useCallback((pageSize: number) => {
		setParams((prev) => ({ ...prev, page: 1, page_size: pageSize }))
	}, [])

	return (
		<div className="space-y-6">
			{/* 页面标题 */}
			<div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
				<div className="flex flex-col gap-1">
					<h1 className="text-2xl font-bold tracking-tight">保证金明细</h1>
					<p className="text-muted-foreground">查看保证金余额和变动记录</p>
				</div>
				<div className="flex items-center gap-2">
					<Button variant="outline" size="sm" onClick={handleRefresh}>
						<RefreshCw className="mr-1.5 h-4 w-4" />
						刷新
					</Button>
				</div>
			</div>

			{/* 余额卡片 */}
			<Card>
				<CardContent className="flex items-center gap-4 py-4">
					<div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
						<Wallet className="h-5 w-5 text-primary" />
					</div>
					<div>
						<p className="text-sm text-muted-foreground">当前保证金余额</p>
						<p className="text-2xl font-bold font-mono">
							{isBalanceLoading ? '--' : `¥${(balance ?? 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
						</p>
					</div>
				</CardContent>
			</Card>

			{/* 变动记录表格 */}
			<DepositLogTable
				logs={data?.list || []}
				isLoading={isLoading}
			/>

			{/* 分页 */}
			<ListPagination
				page={params.page}
				pageSize={params.page_size}
				total={data?.total || 0}
				onPageChange={handlePageChange}
				onPageSizeChange={handlePageSizeChange}
			/>
		</div>
	)
}
